import { ITenant } from "../../AbmLocalPage/types";
import { axiosInstanceMain } from "./../../../utils/axiosGlobalUtils";

export const EnviarMensajeContacto = async (
  idLocal: number,
  data: any,
  tenant: ITenant
) =>
  await axiosInstanceMain.post(`${tenant.path}/contactos/local/${idLocal}`, {
    descripcion: data,
    versionApp: "backoffice",
  });
